module.exports = __webpack_public_path__ + "img/helloromania.f6d37f21.png";